const geolocationErrorCodes = {
  'invalid-coordinate-provided': 'ungültige Koordinate bereitgestellt',
  'server-error-while-updating-coordinates': 'Fehler auf dem Server beim Aktualisieren der Koordinaten',
  'error-while-updating-coordinates': 'Fehler beim Aktualisieren der Koordinaten',
  'server-error-while-getting-coordinates': 'Fehler auf dem Server beim Abrufen der Koordinaten',
  'not-coordinates-funded': 'Koordinaten nicht gefunden'
};

export default geolocationErrorCodes;
